import { Injectable, LOCALE_ID, inject } from '@angular/core';

import { map } from 'rxjs';

import { CamBaseStrapiService, HandleComplexRequest } from '@camelot/server';

import { Sale } from './dto/sale';
import { GET_SALE_CONTENT } from './queries';

@Injectable({
  providedIn: 'root',
})
export class CamSaleService extends CamBaseStrapiService {
  readonly local = inject(LOCALE_ID);

  readonly saleContents = new HandleComplexRequest<Sale>();

  // CamBaseService prend `apiRoutes?` : sans constructeur propre, la factory DI heritee est invalide
  constructor() {
    super();
  }

  public fetchSaleContents$(tenantId: string) {
    return this.saleContents.fetch(
      tenantId,
      this._strapiService
        .fetchQueryList$<Sale>(GET_SALE_CONTENT(tenantId, this.local), 'contentSales')
        .pipe(map(list => list[0]))
    );
  }
}
